import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { UiUser } from "src/app/shared/models/ui-user.model";
import { PaginationModel } from "src/app/shared/models/common";
import { CommonModule } from "@angular/common";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { TooltipDirective } from "src/app/shared/components/ui/tooltip.directive";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.scss"],
  standalone: true,
  imports: [CommonModule, TableComponent, TooltipDirective, TranslateModule],
})
export class UsersListComponent {
  constructor() {}

  @Input() totalRecords: number;
  @Input() numberOfRows: number;
  @Input() users: UiUser[];
  @Output() requestUpdate = new EventEmitter<PaginationModel>();
  @Output() onEditUser = new EventEmitter<UiUser>();

  editUser($event: UiUser) {
    this.onEditUser.emit($event);
  }

  outputPaginationData($event: PaginationModel) {
    this.requestUpdate.emit($event);
  }
}
